import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { moduleName } from '../../constants';
import { URI } from '../../constants/URI';
import { setPromotions } from '../slices/promotionsSlice';
import { store } from '../store';

export const getPromotions = async (body) => {
    const res = await handlePostRequest(URI.promotions, body, {
        module: moduleName.PROMOTIONS,
    });
    if (res?.ack) store.dispatch(setPromotions(res?.promotions));
    return res;
};

export const getPromotionsByCustomer = async (body) => {
    const res = await handlePostRequest(URI.promotion_by_customer, body, {
        module: moduleName.PROMOTION_BY_CUSTOMER,
    });
    return res;
};

export const addPromotion = async (body) => {
    const res = await handlePostRequest(URI.promotion, body, {
        module: moduleName.ADD_PROMOTION,
    });
    return res;
}

export const addPromotionProducts = async (body) => {
    const res = await handlePostRequest(URI.promotion_products, body, {
        module: moduleName.ADD_PROMOTION_PRODUCTS,
    });
    return res;
}

export const getPromotion = async (id) => {
    const res = await handleGetRequest(URI.promotion, null, {
        module: moduleName.PROMOTIONS,
        params: { id },
    });
    return res;
}

export const updatePromotion = async (body) => {
    const res = await handlePutRequest(URI.promotion, body, {
        module: moduleName.PROMOTIONS,
    });
    return res;
}

export const deletePromotion = async (body) => {
    const res = await handleDeleteRequest(URI.promotion, body);
    if (res?.ack) getPromotions()
    return res;
}

export const postPromotion = async (body) => {
    const res = await handlePostRequest(URI.post_promotion, body, {
        module: moduleName.POST_PROMOTION,
    });
    return res;
}